import { FC } from "react";
import classNames from "classnames";

import Skeleton from "../../../../components/Skeleton/Skeleton";

import styles from "./SourceDetailChartSkeleton.module.css";

const CHART_HEIGHT = 330;
const LEGEND_ITEMS = 5;

const SourceDetailChartSkeleton: FC<{ className?: string }> = ({
  className,
}) => (
  <div
    className={classNames(styles["source_detail_chart_skeleton"], className)}
    aria-busy="true"
    aria-label="Loading chart"
  >
    <div className={styles["source_detail_chart_skeleton__legend"]}>
      {Array.from({ length: LEGEND_ITEMS }).map((_, i) => (
        <div
          key={i}
          className={styles["source_detail_chart_skeleton__legend_item"]}
        >
          <Skeleton
            width={20}
            height={20}
            className={styles["source_detail_chart_skeleton__legend_swatch"]}
          />
          <Skeleton height={16} width={72} variant="text" />
        </div>
      ))}
    </div>
    <div className={styles["source_detail_chart_skeleton__chart"]}>
      <Skeleton height={CHART_HEIGHT} variant="text" />
    </div>
  </div>
);

export default SourceDetailChartSkeleton;
